import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import Tagline from './Tagline';
import ShareSocialLinks from './ShareSocialLinks';
import {Row, Col} from 'reactstrap';

export default class ShareSocialContainer extends Component{
    render(){
        return(
            <Row id="share-social-container">
                <Col xs={12} sm={12} md={12}>
                    <Tagline/>
                </Col>
                {/* <Col xs={12} sm={12} md={6}>
                    <ShareSocialLinks
                      onModalLine={this.props.onModalLine}
                    />
                </Col> */}
            </Row>

        )
    }
}